import { Dialog, Typography } from "@mui/material";
import { AwardWinners } from "../utils/helper";

interface Props {
  open: boolean;
  onClosingAwardModal: () => void;
  selectedAwardee: AwardWinners | null;
}

function AwardModal(props: Props) {
  const { open, onClosingAwardModal } = props;

  return (
    <Dialog
      open={open}
      onClose={onClosingAwardModal}
      fullWidth={true}
      maxWidth="sm"
    >
      <div
        style={{
          padding: 10,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
        }}
      >
        <Typography style={{ fontWeight: "bold" }}>
          {" "}
          {props?.selectedAwardee?.heading}
        </Typography>
        <Typography fontSize={12} style={{ fontWeight: "bold" }}>
          {props?.selectedAwardee?.emp_name}
        </Typography>
        <img
          src={`awards/${props?.selectedAwardee?.emp_name}.jpg`}
          style={{ width: "180px", height: "200px" }}
        />
        <Typography fontSize={11.5} style={{ fontWeight: "bold" }}>
          {props?.selectedAwardee?.department}
        </Typography>
        <Typography fontSize={11.5}>
          {props?.selectedAwardee?.description}
        </Typography>
      </div>
    </Dialog>
  );
}

export default AwardModal;
